import get from "lodash/get";
import set from "lodash/set";
import uniq from "lodash/uniq";
import { ReactNode, useCallback, useState } from "react";
import { AccordionContext } from "./accordion.context";

export type AccordionProviderProps = {
  children: ReactNode;
  isSingle: boolean;
};

export function AccordionProvider({
  children,
  isSingle,
}: AccordionProviderProps) {
  const [listeners, setListeners] = useState<
    Record<string, CallableFunction[]>
  >({});

  const addEventListener = useCallback(
    (event: string, listener: CallableFunction) => {
      setListeners((listeners) => {
        const eventListeners = get(listeners, event, []);

        set(listeners, event, uniq([...eventListeners, listener]));

        return { ...listeners };
      });
    },
    [setListeners]
  );

  const dispatchEvent = useCallback(
    (event: string, payload: Record<string, unknown>) => {
      const eventListeners = get(listeners, event, []);

      eventListeners.forEach((listener) => listener(payload));
    },
    [listeners]
  );

  const removeEventListener = useCallback(
    (event: string, listener: CallableFunction) => {
      setListeners((listeners) => {
        const eventListeners = get(listeners, event, []);

        set(
          listeners,
          event,
          eventListeners.filter((item) => item !== listener)
        );

        return { ...listeners };
      });
    },
    [setListeners]
  );

  return (
    <AccordionContext.Provider
      value={{ addEventListener, dispatchEvent, removeEventListener, isSingle }}
    >
      {children}
    </AccordionContext.Provider>
  );
}
